import React from 'react';
import { ProgressBar } from '@/components/ui';

interface CoursesCompletedWidgetProps {
  coursesCompleted: number;
  coursesTotal: number;
  icon: string;
}

export const CoursesCompletedWidget: React.FC<CoursesCompletedWidgetProps> = ({ coursesCompleted, coursesTotal, icon }) => {
  return (
    <div className="bg-white flex min-w-60 flex-col overflow-hidden items-stretch justify-center flex-1 shrink basis-[0%] my-auto px-5 py-4 rounded-[10px]">
      {/* Row 1: Icon */}
      <div className="flex w-full items-center">
        <img
          src={icon}
          alt="Courses"
          className="aspect-square object-contain object-center w-8 overflow-hidden shrink-0"
        />
      </div>

      {/* Row 2: Title */}
      <div className="text-[#2D2D2D] text-base font-medium leading-none tracking-[-0.32px] mt-4">
        Total Courses Completed
      </div>

      {/* Row 3: Progress Bar with Label */}
      <div className="mt-3 w-full">
        <ProgressBar
          progress={coursesCompleted}
          maxValue={coursesTotal}
          showLabel={true}
          className="w-full justify-between"
        />
      </div>
    </div>
  );
};
